module.exports = __webpack_public_path__ + "static/img/Gold Nova I.733e7a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/csgo/ranks/Gold Nova I.png
// module id = D9Qg
// module chunks = 35